(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kefit-category"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initDrag(viewport) {
    if (!viewport || viewport.dataset.kefitDragReady === '1') return;
    viewport.dataset.kefitDragReady = '1';

    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return;

      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = viewport.scrollLeft;

      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(event.pointerId);
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!dragging) return;

      var distance = event.clientX - startX;

      if (Math.abs(distance) > 5) moved = true;

      viewport.scrollLeft = startScroll - distance;
    });

    function endDrag() {
      if (!dragging) return;

      dragging = false;
      viewport.classList.remove('is-dragging');

      if (moved) {
        window.setTimeout(function () {
          viewport.dataset.kefitDragged = '1';
          window.setTimeout(function () {
            delete viewport.dataset.kefitDragged;
          }, 80);
        }, 0);
      }
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('lostpointercapture', endDrag);

    viewport.addEventListener('click', function (event) {
      if (viewport.dataset.kefitDragged === '1') {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);
  }

  function initArrows(root) {
    var viewport = root.querySelector('[data-kefit-catgrid-viewport]');
    var prev = root.querySelector('[data-kefit-catgrid-prev]');
    var next = root.querySelector('[data-kefit-catgrid-next]');

    if (!viewport || !prev || !next || root.dataset.kefitArrowsReady === '1') return;
    root.dataset.kefitArrowsReady = '1';

    function getStep() {
      var item = viewport.querySelector('.kefit-catgrid__item');
      if (!item) return viewport.clientWidth * 0.8;

      var gap = parseFloat(getComputedStyle(item.parentElement).gap) || 18;
      return item.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = viewport.scrollWidth - viewport.clientWidth;
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= max - 2;
    }

    prev.addEventListener('click', function () {
      viewport.scrollBy({ left: -getStep() * 2, behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      viewport.scrollBy({ left: getStep() * 2, behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initReveal(root) {
    if (!root || root.dataset.kefitRevealReady === '1') return;
    root.dataset.kefitRevealReady = '1';

    // JS explicitly takes control of the reveal animation.
    // If JS fails or the editor injects the section before initialization,
    // the CSS fallback keeps all categories visible instead of hiding them.
    root.classList.add('kefit-catgrid--js');

    if (
      (window.Shopify && Shopify.designMode) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)
    ) {
      root.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        root.classList.add('is-visible');
        observer.unobserve(root);
      });
    }, {
      threshold: 0.18,
      rootMargin: '0px 0px -8% 0px'
    });

    observer.observe(root);
  }

  function init(root) {
    if (!root || root.dataset.kefitCatgridReady === '1') return;
    root.dataset.kefitCatgridReady = '1';

    initDrag(root.querySelector('[data-kefit-catgrid-viewport]'));
    initArrows(root);
    initReveal(root);
  }

  function boot(scope) {
    var target = scope || document;

    // Shopify's section:load event can provide the section element itself.
    // querySelectorAll() does not include that element, so initialize it
    // explicitly before scanning its descendants.
    if (target.matches && target.matches('[data-kefit-catgrid]')) {
      init(target);
    }

    target.querySelectorAll('[data-kefit-catgrid]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kefit-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (!root || root.dataset.kefitHeroReady === 'true') return;
      var viewport = root.querySelector('[data-kefit-viewport]');
      var track = root.querySelector('[data-kefit-track]');
      if (!viewport || !track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-kefit-slide]'));
      if (slides.length === 0) return;
      root.dataset.kefitHeroReady = 'true';

      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-kefit-dot]'));
      var prevBtn = root.querySelector('[data-kefit-prev]');
      var nextBtn = root.querySelector('[data-kefit-next]');

      var count = slides.length;
      var loop = root.dataset.loop === 'true' && count > 1;
      var autoplay = root.dataset.autoplay === 'true' && count > 1;
      var interval = parseInt(root.dataset.interval, 10) || 5000;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Clone edges for infinite loop
      if (loop) {
        var firstClone = slides[0].cloneNode(true);
        var lastClone = slides[count - 1].cloneNode(true);
        firstClone.setAttribute('aria-hidden', 'true');
        lastClone.setAttribute('aria-hidden', 'true');
        firstClone.removeAttribute('data-kefit-slide');
        lastClone.removeAttribute('data-kefit-slide');
        track.appendChild(firstClone);
        track.insertBefore(lastClone, track.firstChild);
      }

      var index = 0;          // logical index
      var offset = loop ? 1 : 0;
      var timer = null;
      var animating = false;
      var pendingIndex = null;    // last-requested target while a transition is in flight
      var animationWatchdog = null;

      function width() {
        return viewport.getBoundingClientRect().width;
      }

      function place(animate) {
        // % based, not px — avoids a forced layout read on every tick/click.
        var xPercent = -(index + offset) * 100;
        if (animate && !reduce) {
          track.classList.add('is-animating');
        } else {
          track.classList.remove('is-animating');
        }
        track.style.transform = 'translate3d(' + xPercent + '%,0,0)';
      }

      function syncDots() {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === ((index % count) + count) % count);
        });
      }

      function armWatchdog() {
        if (animationWatchdog) window.clearTimeout(animationWatchdog);
        animationWatchdog = window.setTimeout(settle, 650); // transition is 480ms, headroom for slow devices
      }

      // Runs once a transition genuinely finishes (or the watchdog forces it).
      // Resolves the infinite-loop clone jump, then immediately applies any
      // queued navigation so fast clicking/swiping feels continuous instead
      // of being dropped.
      function settle() {
        if (animationWatchdog) { window.clearTimeout(animationWatchdog); animationWatchdog = null; }
        animating = false;
        if (loop) {
          if (index >= count) { index = 0; place(false); }
          else if (index < 0) { index = count - 1; place(false); }
        }
        if (pendingIndex !== null) {
          var target = pendingIndex;
          pendingIndex = null;
          goTo(target, true);
        }
      }

      track.addEventListener('transitionend', function (e) {
        if (e.target !== track || e.propertyName !== 'transform') return;
        settle();
      });

      function goTo(next, animate) {
        if (!loop) {
          next = Math.max(0, Math.min(count - 1, next));
        }
        if (animating && animate) {
          // Only the latest request is kept — rapid clicks feel like one
          // continuous motion rather than being queued up one-by-one.
          pendingIndex = next;
          return;
        }
        index = next;
        if (animate && !reduce) {
          animating = true;
          armWatchdog();
        }
        place(animate);
        syncDots();
      }

      function next() { goTo(index + 1, true); }
      function prev() { goTo(index - 1, true); }

      function start() {
        if (!autoplay) return;
        stop();
        timer = window.setInterval(next, interval);
      }
      function stop() {
        if (timer) { window.clearInterval(timer); timer = null; }
      }

      if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.getAttribute('data-kefit-dot'), 10), true);
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      // Drag / swipe — all math done in % so it matches place() exactly,
      // and interrupting a mid-flight transition never causes a jump.
      var startX = 0, startY = 0, delta = 0, dragging = false, locked = false, pointerId = null;
      var cachedWidth = 0, dragBasePercent = 0;

      function currentTransformPercent() {
        var computed = window.getComputedStyle(track).transform;
        if (!computed || computed === 'none') return -(index + offset) * 100;
        var nums = computed.replace(/matrix(3d)?\(|\)/g, '').split(',').map(parseFloat);
        var txPx = nums.length === 16 ? nums[12] : nums[4]; // matrix3d vs matrix
        return (txPx / cachedWidth) * 100;
      }

      function onDown(e) {
        if (count < 2) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        pointerId = e.pointerId;
        dragging = true;
        locked = false;
        delta = 0;
        startX = e.clientX;
        startY = e.clientY;
        cachedWidth = width();
        // Autoplay/transition are only touched once a horizontal drag is
        // confirmed below — a plain page-scroll must never interrupt anything.
      }

      function onMove(e) {
        if (!dragging || e.pointerId !== pointerId) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (!locked) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { dragging = false; return; }
          locked = true;
          stop();
          // Snap-safe interrupt: capture wherever the slide visually is
          // right now (even mid-transition) instead of assuming it's at rest.
          dragBasePercent = currentTransformPercent();
          if (animationWatchdog) { window.clearTimeout(animationWatchdog); animationWatchdog = null; }
          animating = false;
          pendingIndex = null;
          track.classList.remove('is-animating');
          viewport.classList.add('is-dragging');
          if (viewport.setPointerCapture) {
            try { viewport.setPointerCapture(pointerId); } catch (err) {}
          }
        }
        delta = dx;
        if (!loop) {
          if ((index === 0 && dx > 0) || (index === count - 1 && dx < 0)) delta = dx * 0.35;
        }
        var deltaPercent = (delta / cachedWidth) * 100;
        track.style.transform = 'translate3d(' + (dragBasePercent + deltaPercent) + '%,0,0)';
        if (e.cancelable) e.preventDefault();
      }

      function onUp(e) {
        if (!dragging) return;
        dragging = false;
        if (!locked) return; // was just a scroll/tap, nothing was touched
        viewport.classList.remove('is-dragging');
        var threshold = Math.max(40, cachedWidth * 0.12);
        if (Math.abs(delta) > threshold) {
          if (delta < 0) next(); else prev();
        } else {
          place(true);
        }
        var block = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
        viewport.addEventListener('click', block, { capture: true, once: true });
        locked = false;
        delta = 0;
        start();
      }

      viewport.addEventListener('pointerdown', onDown);
      viewport.addEventListener('pointermove', onMove, { passive: false });
      viewport.addEventListener('pointerup', onUp);
      viewport.addEventListener('pointercancel', onUp);
      viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // Keyboard
      viewport.setAttribute('tabindex', '0');
      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { next(); start(); }
        else if (e.key === 'ArrowLeft') { prev(); start(); }
      });

      // Responsive resize
      var raf = null;
      function reflow() {
        if (raf) window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(function () {
          if (animationWatchdog) { window.clearTimeout(animationWatchdog); animationWatchdog = null; }
          animating = false; // resize always cancels any in-flight transition
          pendingIndex = null;
          place(false);
        });
      }
      if (window.ResizeObserver) {
        new ResizeObserver(reflow).observe(viewport);
      } else {
        window.addEventListener('resize', reflow);
      }

      place(false);
      syncDots();
      start();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-kefit-hero]').forEach(initHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
